import React, { useEffect } from 'react'
import { HashRouter, Route, Routes, Navigate, BrowserRouter } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { set_login_action } from '../src/redux/utils/Action';
import { connect } from 'react-redux';
import { Loading } from './global';

import './scss/style.scss'


// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))

const LoginRoute = ({ children, isLogin }) => {
  return isLogin ? <Navigate to="/" /> : children
};

const MainRoute = ({ children, isLogin }) => {
  return isLogin ? children : <Navigate to="/login" />
};

const App = (props) => {
  useEffect(() => {
    if(localStorage.getItem('token')){
      props.set_login_action(true)
    }else {
      props.set_login_action(false)
    }
  }, []);

  return (
      <BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <React.Suspense fallback={<Loading />}>
          <Routes>
            <Route exact path="*" element={<MainRoute isLogin={props.login}><DefaultLayout /></MainRoute>} />
            <Route exact path="/login" element={<LoginRoute isLogin={props.login}><Login /></LoginRoute>} />
            <Route exact path="/404" element={<Page404 />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
  )
}

const mapStateToProps = state => {
  return {
    login: state.utils.login,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    set_login_action: (data) => dispatch(set_login_action(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);